import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import KivaProxy from "@/utils/kivaProxy/src";
import KvModal from "@/components/kiva/KvModal";
import kvAccount from "@/components/kiva/remote-search/kvAccount";
import { CrmDealTransformer } from "@/transformers/CrmDealTransformer";
import { crmDealModel } from "@/models/crmDealModel";
import dealsMixin from "@/mixins/deals";
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
import { ContactNameTransformer } from "@/transformers/ContactNameTransformer";
import optionsMixin from "@/mixins/options";
import KvProjectSelect from "@/components/kiva/KvProjectSelect";
import labelMixins from "@/mixins/labels";
import moment from 'moment';
export default {
  components: {
    KvModal: KvModal,
    kvAccount: kvAccount,
    kvContacts: function kvContacts() {
      return import("@/components/kiva/remote-search/kvContactsFeatured");
    },
    kvAccounts: function kvAccounts() {
      return import("@/components/kiva/remote-search/kvAccountsFeatured");
    },
    kvLabelInput: function kvLabelInput() {
      return import("@/components/kiva/input/kvLabelInput");
    },
    KvProjectSelect: KvProjectSelect
  },
  mixins: [dealsMixin, optionsMixin, labelMixins],
  props: {
    formLabelWidth: {
      type: String,
      default: "200px"
    },
    id: [String, Number],
    account: [Object],
    addition: {
      type: Object
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getData(_this.id);
            if (_this.account && _this.account.recordId) {
              _this.data.accountName.value = _this.account.recordId;
              _this.data.accountName.label = _this.account.accountName;
              _this.getContacts(false);
            }
            if (_this.project) {
              _this.data.project = _this.project * 1;
            }
            if (_this.addition && _this.addition.extra && _this.addition.extra.contact) {
              _this.defaultNewContact = _this.addition.extra.contact;
            }
            if (_this.addition && _this.addition.extra && _this.addition.extra.account) {
              _this.defaultNewAccount = _this.addition.extra.account;
            }
            _this.loading = true;
            _context.next = 8;
            return _this.getOptions({
              app: "crm",
              model: "deal",
              column: "stage"
            });
          case 8:
            _context.next = 10;
            return _this.getOptions({
              app: "crm",
              model: "deal",
              column: "type"
            });
          case 10:
            _this.getDealType();
            _this.getLeadSource();
            _this.getTags();
            _this.getClosedReasons(0);
            _this.loading = false;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  data: function data() {
    return {
      loading: false,
      dialogFormVisible: true,
      defaultNewContact: {},
      defaultNewAccount: {},
      data: crmDealModel(),
      projects: {},
      contacts: [],
      unRecordedLabels: [],
      changeKey: "changeKey",
      rules: {
        subject: [{
          required: true,
          message: this.$t("Please input this field."),
          trigger: "blur"
        }],
        recordOwner: [{
          required: true,
          message: this.$t("Please select"),
          trigger: "change"
        }],
        'accountName.value': [{
          required: true,
          message: this.$t("Please select"),
          trigger: "change"
        }],
        expectedClosingDate: [{
          required: true,
          message: this.$t("Please enter valid date."),
          trigger: "blur"
        }]
      },
      formOpen: {
        account: false,
        contact: false
      }
    };
  },
  methods: {
    removeDeal: function removeDeal() {
      var _this2 = this;
      this.$confirm("This will permanently delete the deal. Continue?", "Warning", {
        confirmButtonText: this.$t("Ok"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning"
      }).then(function (response) {
        new KivaProxy({
          endpoint: "crm/deal"
        }).destroy(_this2.data.recordId).then(function () {
          _this2.$message({
            type: "success",
            message: _this2.$t("Delete completed")
          });
        }).catch(function () {
          _this2.$message({
            type: "info",
            message: _this2.$t("Delete canceled")
          });
        });
      });
    },
    saveForm: function saveForm() {
      var _this3 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var dealTranformed = CrmDealTransformer.send(_this3.data);
          var module = new KivaProxy({
            endpoint: "crm/deal"
          });
          if (_this3.data.recordId && _this3.data.recordId != 0 && _this3.data.recordId != "new" && _this3.data.recordId != null) {
            module.update(dealTranformed).then(function (response) {
              console.log(response);
              _this3.loading = false;
              _this3.$notify({
                title: _this3.$t("Congratulations"),
                message: _this3.$t("Saving Success"),
                type: "success"
              });
              setTimeout(function () {
                _this3.setDialogFormVisible("", true);
              }, 300);
            });
          } else {
            module.create(dealTranformed).then(function (response) {
              _this3.loading = false;
              var h = _this3.$createElement;
              var record_id = response.records[0].record_id;
              _this3.$store.state.lastUpdate = {
                app: 'crm',
                model: 'deal',
                id: record_id,
                work: "create",
                time: moment().valueOf(),
                data: dealTranformed
              };
              _this3.$store.state.lastUpdate.time = moment().valueOf();
              _this3.saveUncordedLabels(record_id, 'crm', 'deal', _this3.unRecordedLabels);
              if (_this3.data.lead && _this3.data.lead.value) {
                console.log("Remove lead source");
                new KivaProxy({
                  endpoint: "crm/lead"
                }).update({
                  record_id: _this3.data.lead.value,
                  lead_status: 4
                }).then(function (response) {});
              }
              _this3.$notify({
                title: _this3.$t("Congratulations"),
                message: _this3.$t("Creating Success"),
                type: "success"
              });
              _this3.setDialogFormVisible("", true);
            }).catch(function (err) {
              console.log(err);
            });
          }
        }
      });
    },
    setDialogFormVisible: function setDialogFormVisible(val, isListRefresh) {
      this.$emit("setDialogFormVisible", val);
      // if (isListRefresh) {
      //   this.$emit("listAgain", true);
      // }
    },
    getData: function getData() {
      var _this4 = this;
      if (this.id && this.id != "new" && this.id != "undefined") {
        this.loading = true;
        new KivaProxy({
          endpoint: "crm/deal"
        }).find(this.id).then(function (response) {
          _this4.loading = false;
          _this4.data = CrmDealTransformer.fetch(response.record);
          if (_this4.addition && _this4.addition.force) {
            Object.assign(_this4.data, _this4.addition.force);
          }
        }).finally(function () {
          _this4.loading = false;
        });
      } else {
        var me = this.$store.state.users.CURRENT_USER;
        this.data.recordOwnerLabel = me.fullName;
        this.data.recordOwner = me.userId;
        if (this.addition && this.addition.force) {
          Object.assign(this.data, this.addition.force);
        }
      }
    },
    getContacts: function getContacts(removeFirst) {
      var _this5 = this;
      if (removeFirst) {
        this.data.contactName = 0;
        this.data.contactNameLabel = 0;
      }
      this.loading = true;
      if (this.data.accountName) {
        new KivaProxy({
          endpoint: "crm/contact"
        }).setFilters({
          account_name: ["=", this.data.accountName.value]
        }).all().then(function (response) {
          _this5.loading = false;
          _this5.contacts = ContactNameTransformer.fetchCollection(response.records);
          console.log("console", _this5.contacts);
        }).finally(function () {
          _this5.loading = false;
        });
      }
    },
    getProjects: function getProjects() {
      var _this6 = this;
      this.loading = true;
      new KivaProxy({
        endpoint: "act/project"
      }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_color", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "use_threads", "approval_required", "use_sections", "section_required", "time"]).all().then(function (response) {
        _this6.loading = false;
        // console.log(response.records)
        _this6.projects = response.records;
      });
    }
  },
  watch: {
    dialogFormVisible: function dialogFormVisible() {
      this.setDialogFormVisible("", true);
    },
    "data.accountName.value": function dataAccountNameValue(val) {
      this.getContacts();
    }
  }
};